/**
 * Description component.
 */
import Overlay from '@components/atoms/container/descriptionOverlay';
import Header from '@components/sections/description/descriptionHeader';
import Content from '@components/sections/description/descriptionContent';
import DescriptionContext from '@shared/components/utils/context/descriptionContext';
import useDescription from './useDescription';
import { ContextType } from '@shared/types/enums/context';
import { memo } from 'react';
import { useAppSelector } from '@shared/store/hooks';
import { routerSelector } from '@shared/store/slices/router.slice';
import Pages from '@pages';

/**
 * Description props.
 */
interface Props {
  type?: ContextType;
}

/**
 * Displays the description of the currently focused asset in a rail.
 */
function Description({ type = ContextType.MAIN }: Props) {
  const context = useDescription(type);
  const { route } = useAppSelector(routerSelector);
  return (
    <DescriptionContext.Provider value={context}>
      {context.display ? (
        <>
          <Header />
          <Content />
          {context.alternateTip && route.Page === Pages.CHANNELS_GRID ? (
            <Overlay />
          ) : null}
        </>
      ) : null}
    </DescriptionContext.Provider>
  );
}

export default memo(Description);
